export default __webpack_public_path__ + "static/logo29-929e4c5940874518a1b8c259b717fb4e.png";